import { render, staticRenderFns } from "./viewOnboardedStudentClassDetails.vue?vue&type=template&id=4dd05291"
import script from "./viewOnboardedStudentClassDetails.vue?vue&type=script&lang=js"
export * from "./viewOnboardedStudentClassDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports